module.exports = __webpack_public_path__ + "img/asian-chicken-broccoli-1.24360b6a.jpg";